import styled, { css } from 'styled-components';
import { getSpacingToken, getTextTokenPreset } from '@optimus-web/core';
import {
    getSystemWideBannerBackgroundColor,
    getSystemWideBannerIconColor,
    getSystemWideBannerTextColor,
} from './getSystemWIdeBannerStyles';
import { SystemWideBannerImportance, SystemWideBannerVariant } from './types';

interface SystemWideBannerContainerProps {
    centered?: boolean;
    importance: SystemWideBannerImportance;
    variant: SystemWideBannerVariant;
}

export const SystemWideBannerContainer = styled.div<SystemWideBannerContainerProps>`
    display: flex;
    align-items: center;
    padding: ${getSpacingToken('200')}px;
    color: ${getSystemWideBannerIconColor};
    background-color: ${getSystemWideBannerBackgroundColor};
    ${({ centered }) =>
        centered &&
        css`
            justify-content: center;
        `}
`;

interface SystemWideBannerTextElementProps {
    hasIcon: boolean;
    importance: SystemWideBannerImportance;
    centered?: boolean;
    variant: SystemWideBannerVariant;
}

export const SystemWideBannerTextElement = styled.span<SystemWideBannerTextElementProps>`
    ${getTextTokenPreset('bodyMediumStrong')};
    color: ${getSystemWideBannerTextColor};
    ${({ centered }) =>
        !centered &&
        css`
            flex: 1;
        `}
    ${({ hasIcon }) =>
        hasIcon &&
        css`
            margin-left: ${getSpacingToken('200')}px;
        `}
`;
